import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import FieldGroup from '../field_group/FieldGroup';
import Form from '../form/Form';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';
import { listBoilerType } from '../../redux/references/hot_water_system_actions';

export class BoilerDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  getBoilerData() {
    return this.formRef.getFormData();
  }

  componentDidMount() {
    if (this.props.listBoilerType) {
      this.props.listBoilerType();
    }
  }

  renderOption(item) {
    return (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  render() {
    const {
      name,
      type_id,
      efficiency,
      description,
      image,
    } = this.props.boiler;
    const { disabled, fieldErrors, t, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => this.formRef = ref}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="hot-water-boiler-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('boiler name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="hot-water-boiler-type"
          field="type_id"
          componentClass="select"
          label={t('type')}
          value={type_id}
          defaultDirty={true}
          errorMessage={getErrorValue(fieldErrors, 'type_id')}
          {...customAttr}
        >
          {this.props.boilerTypeList.map(type => this.renderOption(type))}
        </FieldGroup>
        <FieldGroup
          id="hot-water-boiler-efficiency"
          field="efficiency"
          type="number"
          label={<span>Efficiency (%)</span>}
          placeholder="80"
          value={efficiency}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'efficiency')}
          {...customAttr}
        />
        <FieldGroup
          id="hot-water-boiler-description"
          field="description"
          componentClass="textarea"
          label="Description"
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

BoilerDetail.defaultProps = {
  boiler: {},
};

const mapStateToProps = state => ({
  boilerTypeList: state.reference.hotWaterSystem.boilerTypeList,
});

const mapDispatchToProps = dispatch => ({
  listBoilerType: () => dispatch(listBoilerType()),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(BoilerDetail)
);



// WEBPACK FOOTER //
// ./src/components/hot_water_system/BoilerDetail.js